import { useContext, useEffect, useState } from 'react'
import { Download, Edit, TrashAlt } from '@styled-icons/boxicons-solid'

import Button from '../../common/Button'
import InputText from '../../common/InputText'
import LinkWithStatus from '../../common/LinkWithStatus'
import { NavContext } from '../../../context/global_context'
import Tooltip from '../../common/tooltip'
import Pagination from '../../common/Pagination'
import NoRecordsFound from '../../common/NoRecordsFound'
import { deleteRequest, getRequest } from '../../../services/base'
import { downloadFileBlob } from '../../../utils/common'
import {
  AppsContext,
  SET_APPS_DATA,
  SET_SELECTED_APPS_DATA,
  SHOW_APPS_FORM,
} from './context/context'
import AppsForm from './form'

const AppsRow = (props) => {
  return (
    <div className="flex flex-row flex-wrap items-center bg-white w-full py-2 px-3 border-b border-tracer-dark-blue text-black">
      <div className="flex flex-row w-full">
        <div className="flex w-5/12 pl-6 items-center table_text">
          <Tooltip message={props?.name}>
            <div>{props.name}</div>
          </Tooltip>
        </div>
        <div className="flex w-5/12 pl-6 items-center table_text">
          <Tooltip message={props?.client_id}>
            <div>{props.client_id}</div>
          </Tooltip>
        </div>

        <div className="flex w-2/12 pl-6 justify-end ">
          <div>
            <span
              onClick={() => {
                props.onEdit()
              }}
              className="cursor-pointer p-2"
            >
              <Edit size="2rem" color="#0189E9" />
            </span>
            <span
              onClick={() => {
                props.onDelete()
              }}
              className="cursor-pointer p-2"
            >
              <TrashAlt size="2rem" color="#0189E9" />
            </span>
            <span
              onClick={() => {
                props.downloadCredentials()
              }}
              className="cursor-pointer p-2"
            >
              <Download size="2rem" color="#0189E9" />
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}

const OAuthApps = () => {
  const [state, dispatch] = useContext(AppsContext)
  const [navState, navDispatch] = useContext(NavContext)
  const [searchValue, setSearchValue] = useState('')
  const [pagination, setPagination] = useState({})

  useEffect(() => {
    getAppsData('', true)
  }, [])

  const deleteApp = async (id, name) => {
    if (
      window.confirm(`Are you sure want to delete selected ${name}`) === true
    ) {
      let res = await deleteRequest(`/api/oauth/${id}/`)
      navDispatch({
        type: 'notification',
        data: {
          notification_type: 'success',
          msg: `App Deleted Successfully`,
        },
      })
      getAppsData('', false)
      dispatch({
        type: SET_SELECTED_APPS_DATA,
        data: {},
        showFormPopup: false,
      })
    }
  }

  const downloadCredentials = async (id, client_id, name) => {
    navDispatch({
      type: 'loader',
      data: {
        caption: `Downloading Credentials file is in progress.`,
        showLoader: true,
      },
      notification: {},
    })

    let res = await getRequest(
      `/api/oauth/download/${id}/${client_id}/`,
      true,
      true
    )
    if (res?.msg) {
      navDispatch({
        type: 'notification',
        data: {
          notification_type: 'error',
          msg: res?.msg,
        },
      })
    } else {
      downloadFileBlob(res, `${name}-credentials.csv`)
      navDispatch({
        type: 'notification',
        data: {
          notification_type: 'success',
          msg: 'File Download completed.',
        },
      })
    }
  }

  const getAppsData = async (url = null, showLoader = false) => {
    if (showLoader) {
      navDispatch({
        type: 'loader',
        data: {
          caption: 'Fetching Apps Data',
          showLoader: true,
        },
        notification: {},
      })
    }

    let res = await getRequest(url ? url : `/api/oauth/?search=${searchValue}`)
    dispatch({ type: SET_APPS_DATA, data: res.results })
    setPagination(res.pagination)
    if (showLoader) {
      navDispatch({
        type: 'loader',
        data: {},
        notification: {},
      })
    }
  }

  return (
    <div>
      <AppsForm
        getAppList={() => {
          getAppsData('', false)
        }}
      />
      <form
        className="flex flex-col w-full space-y-2 pb-5"
        acceptCharset="UTF-8"
        onSubmit={(e) => {
          e.preventDefault()
        }}
      >
        <div className="flex space-x-5">
          <div className="flex w-6/12 font-light text-right space-x-5">
            <InputText
              name="search"
              value={searchValue}
              type="search"
              placeholder={`Enter To Search Apps`}
              onChange={(e) => {
                setSearchValue(e)
              }}
              wrapperClass={`p-0`}
              isFullSize={false}
              className="h-10 px-5 pr-5"
              isRequired={false}
            />
            <Button
              className={`bg-tracer-lt-blue font-light hover:bg-blue-700 text-white py-2 px-3 rounded`}
              onClick={() => {
                getAppsData('', true)
              }}
              text="Search"
            />
          </div>
          <div className="flex w-6/12 font-light text-right space-x-5 justify-end">
            <LinkWithStatus
              href={`/administration/app/new`}
              className={
                'cursor-pointer inline-block bg-tracer-lt-blue font-light hover:bg-blue-700 text-white py-2 px-3 rounded'
              }
              title="Setup New App"
              onClickFunc={() => {
                dispatch({
                  type: SHOW_APPS_FORM,
                  data: {},
                  showFormPopup: true,
                })
              }}
            />
          </div>
        </div>
      </form>
      <div className="font-light">
        <div className="flex flex-row w-full bg-tracer-lt-blue rounded-t-lg text-white px-3 text-sm">
          <div className="flex w-5/12 pl-6 items-center">Name</div>
          <div className="flex w-5/12 pl-6 items-center">Client Id</div>
          <div className="w-2/12 pl-6"></div>
        </div>
      </div>
      {state?.data?.map((app, index) => {
        return (
          <AppsRow
            key={`app-${app.id}-${index}`}
            {...app}
            onEdit={() => {
              dispatch({
                type: SET_SELECTED_APPS_DATA,
                data: { ...app, index: index },
                showFormPopup: true,
              })
            }}
            onDelete={() => {
              deleteApp(app.id, app.name)
            }}
            downloadCredentials={() => {
              downloadCredentials(app.id, app.client_id, app.name)
            }}
          />
        )
      })}
      {state?.data?.length < 1 && <NoRecordsFound />}
      <div className="py-6">
        <Pagination
          context={pagination}
          onClickNext={(e) => {
            getAppsData(e, true)
          }}
          onClickPrev={(e) => {
            getAppsData(e, true)
          }}
        />
      </div>
    </div>
  )
}

export default OAuthApps
